var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomDoneAll = function SvgCustomDoneAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 14.012 2.96 2.22a.916.916 0 0 0 1.258-.153l7.686-9.392",
    stroke: "currentColor",
    strokeWidth: 1.373,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.355 15.465 1.581 1.265a1.602 1.602 0 0 0 2.241-.237l7.668-9.371a.687.687 0 1 0-1.063-.87l-7.668 9.371a.229.229 0 0 1-.32.034l-1.569-1.255-.87 1.063Z",
    fill: "currentColor"
  })));
};

export default SvgCustomDoneAll;